
import {
    Component,
    Vue,
    Inject,
    Prop,
    Watch
} from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';

@Component
export default class Video extends AbpBase {
    toAbnormal(){
        //    this.$emit('show');
       let routeUrl = this.$router.resolve({
          path: "/ycjh/healthyvideo"
        });
        window.open(routeUrl.href, '_blank');
    }
}
